import { useState } from '#imports'

// The subject a map marker is navigating to: its sheet stays at the resting level
// rather than opening full, so the map the user just tapped stays visible.

export function useMapMarkerOrigin() {
  const subject = useState<string | null>(() => null)
  return {
    openedFromMarker: (id: string | null) =>
      id !== null && id === subject.value,
    markMarkerOrigin: (id: string) => {
      subject.value = id
    },
    clearMarkerOrigin: () => {
      subject.value = null
    },
  }
}
